module.exports = __webpack_public_path__ + "static/media/folder.e4ea2677.svg";